import React,{useState,useEffect} from 'react'
import AuthUser from '../AuthUser';
import Dropdown from "react-bootstrap/Dropdown";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Employerslist(props) {
    let usertype = props.logintype;
    let pageview = props.pageview;
    let apiurl = props.apiurl;
    const [applicants, setApplicants] = useState([])
    const [applicantcount, setApplicantcount] = useState(0)
    const [filter, setFilter] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const[message,setMessage]=useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [selectedid, setSelectedid] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [values,setValues]=useState({name:'',lastname:'',email:'',phone:''});
    const [errors, setErrors] = useState({name:'',lastname:'',email:'',phone:''});
    const [phoneNumber, setPhoneNumber] = useState();
    const [country, setCountry] = useState();
    const [countrycode, setCountrycode] = useState();
    const { http, getUser } = AuthUser();
    let userdetails = getUser();
    let dashboard=`/${usertype}`;
    const handlePhoneChange = (phone, data) => {
        // Handle phone number change
        console.log(data);
        //console.log(data.dialCode);
        //console.log(value.target.phone.value)
        //console.log(value.slice(data.dialCode.length));
        console.log(phone)
        setCountrycode(data.countryCode);
        setCountry(data.dialCode);
        //let val = phone.slice(data.dialCode.length);
        setPhoneNumber(phone);
        const phoneNumberPattern = /^\+?[1-9]\d{1,14}$/;
    
        phoneNumberPattern.test(phone);
        setValues({...values,['phone']:phone})
      };
    function fetchItems(){
        http.get(`${usertype}/${apiurl}/${userdetails.email}`)
        .then((response) => {
            console.log(response.data);
            setApplicants(response.data.employerslist);
            setApplicantcount(response.data.employerslist.length);
            setFilteredData(response.data.employerslist);
        })
        .catch(function (error) {
            // handle error
            console.log(error.response.data.error);
        });
    }
    useEffect(() => {
        fetchItems();
    }, []);
    const handleFilterChange = (e) => {
        const value = e.target.value.toLowerCase();
        setFilter(value);

        const filtered = applicants.filter(item =>
            item.name.toLowerCase().includes(value) || item.lastname.toLowerCase().includes(value) || item.email.toLowerCase().includes(value) || item.phone.toLowerCase().includes(value)
            // Add more conditions based on your data structure
        );

        setFilteredData(filtered);
    };
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
          href=""
          ref={ref}
          onClick={e => {
            e.preventDefault();
            onClick(e);
          }}
        >
          {children}
          <span className="threedots" />
        </a>
    ));
    const handleDelete = () => {
        http.post(`${usertype}/deleteemployer`,{employerid:selectedid})
        .then((response) => {
            //console.log(response); 
            fetchItems();
            handleCloseModal();           
        })
        .catch(function (error) {
            // handle error
            console.log(error.response.data.error);
        });
    };

    const handleShowModal = (id) => {
        setSelectedid(id);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setSelectedid(null);
        setShowModal(false);
    };
    const handleCheckboxChange = async (taskId, isChecked) => {
        http.get(`admin/emailStatus?id=${taskId}+&status=${isChecked}`)
        .then((response) => {
            console.log(response.data);
            fetchItems();
        })
        .catch(function (error) {
            // handle error
            console.log(error.response.data.error);
        });
    };
    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const alphaRegex = /^[A-Za-z]+$/;
        const numRegex = /^[0-9\b]+$/;
        // Validate email
        if (!values.name.trim()) {
            newErrors.name = 'First name is required';
            isValid = false;
        } else if(!alphaRegex.test(values.name)){
            newErrors.name='Only Characters allowed';
            isValid = false;
          }else {
            newErrors.name = '';
        }
        if (!values.lastname.trim()) {
            newErrors.lastname = 'Last name is required';
            isValid = false;
        } else if(!alphaRegex.test(values.lastname)){
            newErrors.lastname = 'Only Characters allowed';
            isValid = false;
        }else {
            newErrors.lastname = '';
        }
        if (!values.email.trim()) {
            newErrors.email = 'Email is required';
            isValid = false;
        } else  if(!emailRegex.test(values.email)){
            newErrors.email = 'Email not valid';
            isValid = false;
        }else {
            newErrors.email = '';
        }
        if (!values.phone.trim()) {
            newErrors.phone = 'Mobile number is required';
            isValid = false;
        } else if(!numRegex.test(values.phone)){
            newErrors.phone = 'Only numbers allowed';
            isValid = false;
        }else {
            newErrors.phone = '';
        }
        setErrors(newErrors);
        return isValid;
    };
    function handleChange(e){
        setValues({...values,[e.target.name]:e.target.value})
    }
    const handleSubmit = async(e) =>{
        e.preventDefault();
        //validation(values); 
        let name = values.name;
        let lastname = values.lastname;
        let email = values.email;
        let phone = values.phone;
        let code = country;
        let shortcode = countrycode;
        const newErrors = { ...errors };        
        if (validateForm()) {
          http.post(`admin/addemployee`,{name:name,lastname:lastname,email:email,phone:phone,countrycode:code,shortcode:shortcode}).then((response)=>{
              //setToken(response.data.userdetail,response.data.token,usertype);
              //console.log(response.status);
              fetchItems();
              setMessage('Employer added successfully!');
              console.log(response.data.message);
              
          }).catch(function (error) {
            // handle error
            //console.log(error.response.data.error);
            if(error.response.status===403){
              newErrors.title = error.response.data?.error?.title;
              newErrors.document = error.response.data?.error?.document;
              setErrors(newErrors);
            }
            if(error.response.status===401){
              newErrors.message = error.response.data?.error;
              setErrors(newErrors);
            }
            //setsubmitted(false)
          })
        } else {
          // Form is not valid, display error messages
    
        }
    }
    const applyStatus = (val, id) =>{
        http.get(`/employer/actionemployer?employerid=${id}&statusval=${val}`)
        .then((response) => {
            fetchItems();
        })
        .catch(function (error) {
            // handle error
            console.log(error.response.data.error);
        });
    }
  return (
    <div className="container-fluid">
        <div className="row mb-2 ">
            <div className="col-md-6">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item "><a href="/admin">Dashboard</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Employers</li>
                    </ol>
                </nav>
            </div>
            <div className="col-md-2 small  text-right">
                <div className="row">
                    <input  type="text" name="email" value={filter}
                onChange={handleFilterChange} className="form-control searchEmail" placeholder="Search by First name, last name, phone or email id..." />
                    
                </div>
            </div>
            <div className="col-md-4 text-right">
                <a href="#" onClick={handleShow} className="text-primary pr-3"> <i className="bi bi-plus"></i> Add Employer</a>
                <h6 className="font-weight-bold">Employer count :<span className="text-primary">{applicantcount}</span></h6>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12 pb-5">
                <div className="card  mb-4">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table  data-toggle="table" className="table table-hover table-condensed" 
                                    data-striped="true"  data-sort-name="Quality"  data-sort-order="desc" id="Tabla" data-page-length='10'>
                                <thead>
                                    <tr>
                                        <th data-sortable="true">First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th className="text-center">Tel #</th>
                                        <th data-sortable="true" className="text-center">Country</th>
                                        <th data-sortable="true">Created Date / Time</th>
                                        <th data-sortable="true">Email settings</th>
                                        <th data-sortable="true">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map(applicant =>(
                                        <tr key={applicant.id}>
                                            <td>
                                                <div className="row">
                                                    <div className="col-9">{applicant.name}</div>                                                    
                                                    <div className="col-3">
                                                        <Dropdown>
                                                            <Dropdown.Toggle as={CustomToggle} />
                                                            <Dropdown.Menu size="sm" title="">
                                                            <Dropdown.Item href="javascript:void(0);" onClick={() => applyStatus('I',applicant.id)}>Inactive</Dropdown.Item>
                                                            <Dropdown.Item href="javascript:void(0);" onClick={() => applyStatus('A',applicant.id)}>Active</Dropdown.Item>
                                                            <Dropdown.Item href="#?" onClick={()=>handleShowModal(applicant.id)}>Delete</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{applicant.lastname}</td>
                                            <td>{applicant.email}</td>
                                            <td className="text-center">+1 {applicant.phone}</td>
                                            <td className="text-center">USA</td>
                                            <td >{applicant.created_at}</td>
                                            <td ><Form.Check type="switch" id={applicant.id} checked={applicant.emailsettings === 'true' ? true: false} onChange={(e) => handleCheckboxChange(applicant.id, e.target.checked) } /> </td>
                                            <td className="text-center">{applicant.status }</td>
                                        </tr>
                                    ))

                                    }
                                </tbody>
                            </table>                
                        </div>
                    </div>
                </div>            
            </div>
        </div>
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter" show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <div className="input_fields_wrap">
                    <div className="mb-2 col-md-12">
                        <p style={{ color: '#2D8BB4' }}><strong>Are you sure you want to delete ?</strong></p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="mb-2 col-md-12 text-center">
                    <button type="button" className="btn btn-secondary ml-2" onClick={handleCloseModal}>No</button> 
                    <button type="submit" onClick={handleDelete} className="btn btn-primary ml-2">Yes</button>
                </div>
            </Modal.Footer>
        </Modal>
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter" show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Add Ticket Name</Modal.Title>
            </Modal.Header>
            <form method="POST" onSubmit={handleSubmit}>
            <Modal.Body className='modal-body'>                
                <div class="row">
                    <div class="input_fields_wrap">
                        <div class="mb-2 col-md-12">
                            <label class="form-label small" style={{ color: '#2D8BB4' }}><strong>First Name*</strong></label>
                            <input id="name" name="name" class="input form-control rounded-0 textOnly" type="text" placeholder=" " onChange={handleChange} />
                            <div className="invalid-feedback small">{errors.name}</div>
                        </div>
                        <div class="mb-2 col-md-12">
                            <label class="form-label small" style={{ color: '#2D8BB4' }}><strong>Last Name*</strong></label>
                            <input id="name" name="lastname" class="input form-control rounded-0 textOnly" type="text" placeholder=" " onChange={handleChange} />
                            <div className="invalid-feedback small">{errors.lastname}</div>
                        </div>
                        <div class="mb-2 col-md-12">
                            <label class="form-label small" style={{ color: '#2D8BB4' }}><strong>Email*</strong></label>
                            <input type="Email" class="form-control rounded-0 mt-2 mb-2 input" id="Email" name="email" placeholder=" " onChange={handleChange}/>
                            <div className="invalid-feedback small">{errors.email}</div>
                        </div>
                        <div class="mb-2 col-md-12">
                            <label class="form-label small" style={{ color: '#2D8BB4' }}><strong>Mobile Number*</strong></label>
                             {/* <input type="phone" id="phone" name="phone" class="form-control rounded-0 numbersOnly" onChange={handleChange} placeholder="Mobile Number" /> */ }
                            <PhoneInput  style={{ width:'100% !important' }} country={'us'}  name="phone" value={phoneNumber} onChange={handlePhoneChange}/>
                            <div className="invalid-feedback small">{errors.phone}</div>
                        </div>
                        <div className="alert-success small">{message}</div>
                    </div>                    
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div class="mb-2 col-md-12 mt-5 text-center">
                    <button type="reset" class="btn btn-secondary ml-2" data-dismiss="modal">Cancel</button>
                    <button type="submit" onClick={validateForm} class="btn btn-primary ml-2">Submit</button>
                </div>
            </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default Employerslist